var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"omapi-template-preview__featured-badge om-featured-badge"},[_vm._t("default",function(){return [_vm._v("Featured")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }